import { TypeOfQueryParam } from "..";
import { CPF_AND_LINE_NUMBER_LENGTH } from "../constants";

import { validateDocumentNumber } from "@/utils/ValidateDocumentNumber";
import { validatePhoneNumber } from "@/utils/ValidatePhoneNumber";

export function resolveInvoiceSearchQueryType(
  value: string
): TypeOfQueryParam | "ambiguous" | null {
  if (!value) return null;

  if (value.length === CPF_AND_LINE_NUMBER_LENGTH) {
    const isDocument = validateDocumentNumber(value);
    const isPhone = validatePhoneNumber(value);

    if (isDocument && isPhone) return "ambiguous";

    if (isDocument) return "document";

    if (isPhone) return "lineNumber";

    return null;
  }

  if (validateDocumentNumber(value)) return "document";

  if (validatePhoneNumber(value)) return "lineNumber";

  return null;
}
